'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SIZE_CLASSES = {
  default: '',
  small: 'is--draggable--sm',
  medium: 'is--draggable--md',
  large: 'is--draggable--lg'
};

var emptyBox = _react2.default.createElement('span', null);

function renderChildren(children, childProps, classes) {
  return (0, _react.cloneElement)(children, _extends({
    className: (0, _reactUtils.classNames)(children.props.className, classes)
  }, childProps));
}

function UIDragHandle(props, context) {
  var children = props.children,
      childProps = props.childProps,
      className = props.className,
      position = props.position,
      size = props.size,
      _wrappedWithDnd = props._wrappedWithDnd,
      rest = _objectWithoutProperties(props, ['children', 'childProps', 'className', 'position', 'size', '_wrappedWithDnd']);

  var connectDragSource = context.connectDragSource;

  if (typeof connectDragSource === 'function' && !_wrappedWithDnd) {
    _devLogger2.default.warn({
      message: 'looks like you are trying to use a UIComponents `UIDragHandle` with ui-addon-draggable. Please use `UIDragHandle` from `ui-addon-draggable/draggable/UIDragHandle` instead.'
    });
  }

  var classes = (0, _reactUtils.classNames)('is--draggable', className, SIZE_CLASSES[size], {
    'is--draggable--sized': size !== 'default',
    'is--draggable--trailing': position === 'end',
    'is--draggable--standalone': children === emptyBox
  });
  return renderChildren(children, _extends({}, childProps, rest), classes);
}

UIDragHandle.defaultProps = {
  childProps: {},
  children: emptyBox,
  position: 'start',
  size: 'default'
};

UIDragHandle.propTypes = {
  children: _react.PropTypes.element.isRequired,
  childProps: _react.PropTypes.object,
  className: _react.PropTypes.string,
  position: _react.PropTypes.oneOf(['start', 'end']).isRequired,
  size: _react.PropTypes.oneOf(Object.keys(SIZE_CLASSES)).isRequired
};

UIDragHandle.contextTypes = {
  connectDragSource: _react.PropTypes.func
};

UIDragHandle.displayName = 'UIDragHandle';

exports.default = UIDragHandle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/draggable/UIDragHandle.js
// module id = 435
// module chunks = 0